import type {Plugin, CustomStepConfig} from '../types';
import {logger} from '../../logger';

// List of valid sandbox values. We restrict the usage of sandbox values to a subset of the full list of available values.
const VALID_SANDBOX_VALUES = [
    'allow-forms',
    'allow-scripts',
    'allow-same-origin',
    'allow-popups',
    'allow-popups-to-escape-sandbox',
    'allow-downloads',
];

const buildSandboxAttribute = (
    sandboxValues: string[],
    label: string,
): string =>
    sandboxValues
        .filter(value => {
            const isValid = VALID_SANDBOX_VALUES.includes(value);
            if (!isValid) {
                logger.warn(
                    `Warning: '${value}' is not a valid sandbox value for ${label}.`,
                );
            }
            return isValid;
        })
        .join(' ');

// Plugins run their own scripts, so 'allow-scripts' is applied by default.
export const getPluginSandboxValues = (plugin: Plugin): string =>
    buildSandboxAttribute(
        [...(plugin.sandboxValues ?? []), 'allow-scripts'],
        'plugins',
    );

// Custom steps can just be used to render static HTML content, so no values are applied by default.
export const getCustomStepSandboxValues = (
    customStepConfig: CustomStepConfig | undefined,
): string =>
    buildSandboxAttribute(
        customStepConfig?.sandboxValues ?? [],
        'custom steps',
    );
